import React from "react";
import {DynamicComponentProps} from "../../core/_models";

export function StatCardComponent({config: {label, value}}: DynamicComponentProps) {
    return (
        <div className="card bg-secondary">
            <div className="card-body d-flex flex-column justify-content-between">
                <div className="d-flex flex-column">
                    <div className="text-white fw-bold fs-1 mb-0">{value}</div>
                    <div className="text-white fw-semibold fs-6">{label}</div>
                </div>
            </div>
        </div>
    )
}